export const DYNAMIC_REDUCER_COMPLETE = 'DYNAMIC_REDUCER_COMPLETE';
export const DYNAMIC_FEATURE_COMPLETE = 'DYNAMIC_FEATURE_COMPLETE';
export const LOAD_ASYNC_FEATURES = 'LOAD_ASYNC_FEATURES';
